import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Index: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ElementsSDK.Typography
      className="yilu-Imprint"
      variant="p2"
      dangerouslySetInnerHTML={{ __html: t('data.imprint') }}
    />
  );
};

export default Index;
